import { useCallback, useEffect, useState } from 'react';
import debounce from 'lodash/debounce';

/*
Based on:
   https://github.com/gragland/usehooks
   https://usehooks.com/useWindowSize
with slight improvements like added debounce functionality.
Cleaned a bit too.
*/
const DEBOUNCE_TIME_MS = 250;

export interface WindowSize {
   width?: number,
   height?: number
}

export const useWindowSize = (): WindowSize => {
   const isClient: boolean = typeof window === 'object';
   const getSize = useCallback(() => ({
      width: isClient ? window.innerWidth : undefined,
      height: isClient ? window.innerHeight : undefined
   }),[isClient]);
   const [windowSize, setWindowSize] = useState(getSize);

   useEffect(() => {
      if (!isClient) {
         return;
      }

      const handleResize = () => {
         setWindowSize(getSize());
      };

      const handleResizeDebounced = debounce(handleResize, DEBOUNCE_TIME_MS);

      window.addEventListener('resize', handleResizeDebounced);

      return () => window.removeEventListener('resize', handleResizeDebounced);
   }, [ isClient, getSize ]);

   return windowSize;
};
